export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_Indoor_1920000-1283f0861608a015ea8a5747c235fc4e.avif";